import React from "react";
import { Box } from "@mui/material";
import { customColour } from "../data/colour";
import { useResponsiveFontSize } from "../functions";

const CardComponent = ({
  icon,
  title,
  body,
  titleColor = customColour.lightBlue,
  border = "none",
  // textFontSize = "1rem",
  backgroundImage,
}) => {
  const textFontSize = useResponsiveFontSize();
  return (
    <Box
      sx={{
        border: border,
        borderRadius: "0.75rem",
        padding: "1.5rem",
        width: "auto",
        textAlign: "center",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.5)",
        background: `linear-gradient(
          to right bottom,
          rgba(248, 248, 255, 0.2),
          rgba(248, 248, 255, 0.05)
        )`,
        backgroundImage: backgroundImage,
        "&:hover": {
          transform: "scale(1.05)",
          background: `linear-gradient(
            to right bottom,
            rgba(153, 199, 240, 0.5),
            rgba(153, 199, 240, 0.2)
          )`,
        },
        transition: "transform 0.3s ease-in-out",
      }}
    >
      <img
        src={icon}
        alt={title}
        style={{ width: "2.5rem", marginTop: "1rem" }}
      />
      <h2
        style={{
          fontSize: "1.25rem",
          fontWeight: "400",
          marginTop: "1rem",
          color: titleColor,
        }}
      >
        {title}
      </h2>
      <p
        style={{
          fontSize: textFontSize,
          textAlign: "left",
          fontWeight: "100",
          lineHeight: "1.5rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        {body}
      </p>
    </Box>
  );
};

const CardList = ({
  data,
  textFontSize,
  border,
  gridTemplateColumns = "repeat(2, 1fr)",
  margin = "2.5rem",
  backgroundImage,
}) => {
  return (
    <Box
      sx={{
        display: "grid",
        marginTop: margin,
        marginBottom: margin,
        gridTemplateColumns: gridTemplateColumns,
        gap: "20px",
      }}
    >
      {data.map((item, index) => (
        <CardComponent
          key={index}
          icon={item.icon}
          title={item.title}
          body={item.body}
          border={border}
          textFontSize={textFontSize}
          backgroundImage={backgroundImage}
        />
      ))}
    </Box>
  );
};

export default CardList;
